import type { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useAdminAccess } from "../hooks/useAdminAccess";
import { useSpecificRoleAccess } from "../hooks/useSpecificRoleAccess";

interface OwnerProtectedRouteProps {
  children: ReactNode;
}

const OwnerProtectedRoute: FC<OwnerProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const { hasOwnerAccess, loading: accessLoading } = useAdminAccess();
  const { hasAccess: isSpecificRole, loading: specificRoleLoading } =
    useSpecificRoleAccess();
  const location = useLocation();

  if (loading || accessLoading || specificRoleLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-600 border-t-transparent"></div>
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/authentication/sign-in"
        state={{ from: location }}
        replace
      />
    );
  }

  if (isSpecificRole) {
    return <Navigate to="/location_variant" replace />;
  }

  if (!hasOwnerAccess) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default OwnerProtectedRoute;
